
import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import * as S from "./styles";
import ModalParams from "components/ModalEditParams";

import { DownloadButton } from "components/Buttons/ActionButton";
import { getBeneficiaryType, convertDateFromApi, scrollToTop } from "utils";
import { filters } from "utils/constants";
import { useApi } from "hooks/useApis";
import { Link } from "react-router-dom";
import { Tooltip, Typography } from "@mui/material";
import AgentType from "utils/agentType";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";  
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import * as formatDate from "utils/formatDate";

const TableParams = () => {
  const api = useApi();


  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);


  const agentType = AgentType();
  
  const handleChange = (event, value) => {
    setPage(value);
    scrollToTop();
  };

  const renderFilterName = (obj) => {
    return (
      <div>
        {filters.map((filter, index) => {
          const value = obj[filter.attributeName];
  
          return value !== undefined ? (
            <p key={index}>
              {filter.filter}
            </p>
          ) : null;
        })}
      </div>
    );
  }

  const renderParamValue = (obj) => {
    return (
      <div>
        {filters.map((filter, index) => {
          const value= obj[filter.attributeName];
  
          return value !== undefined ? (
            <p key={index}>
              {value? "Desativação" : "Ativação"}
            </p>
          ) : null;
        })}
      </div>
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getFiltersHistory(page);
        setHistoryData(response)
      } catch (err) {
        // setError(err);
        console.log(err);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <S.TableContainer>
        <Typography variant="h6" style={{ marginBottom: 5, color: '#F9922A', }}>
          Listagem de alterações
        </Typography>
        <S.TableWrapper>
        <S.StyledTable>
          
          <S.StyledTableHead>
            <tr>
              <S.StyledTableHeaderCell style={{width: '10%'}}>Data</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell style={{width: '10%'}}>Agente</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell>Filtro</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell style={{width: '10%'}}>Ação</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell>Justificativa</S.StyledTableHeaderCell>
            </tr>
          </S.StyledTableHead>
          <S.StyledTableBody>
            {historyData.results?.map((row) => {
              return (
                <S.StyledTableRow key={row?.id}>
                  <S.StyledTableCell>{formatDate.brDate(row?.date_history)}</S.StyledTableCell>
                  <S.StyledTableCell>{row?.agent?.name}</S.StyledTableCell>
                  <S.StyledTableCell>
                    {renderFilterName(row)}
                  </S.StyledTableCell>
                  <S.StyledTableCell>
                    {renderParamValue(row)}
                  </S.StyledTableCell>
                  <S.StyledTableCell>
                    {row?.justification}
                  </S.StyledTableCell>
                </S.StyledTableRow>
              );
            })}
          </S.StyledTableBody>
        </S.StyledTable>
        </S.TableWrapper>
        <S.TableFooter>
          <Typography>
            Página {page} de {historyData?.total_pages}
          </Typography>
          <Pagination
            count={historyData?.total_pages}
            page={page}
            onChange={handleChange}
            renderItem={(item) => (
              <PaginationItem
                slots={{ previous: WestIcon, next: EastIcon }}
                {...item}
              />
            )}
          />
        </S.TableFooter>
      </S.TableContainer>
    </>
  );
};

export default TableParams;

